module.exports = __webpack_public_path__ + "71010dff44cc2c8dfb46906c7add051f.svg";